import { ColorPalette as _ColorPalette } from './base/colorPalette';

import { ThemeColors as _ThemeColors } from './themeProvider/theme-colors';

import { StyleObject as _StyleObject } from 'styletron-react';
import {
	useStyletron as _use,
	withStyle as _withStyle,
	styled as _styled,
	LocaleProvider as _LocaleProvider,
	BaseProvider as _BaseProvider,
} from 'baseui';

import { Theme as _Theme } from './themeProvider/ThemeProvider';

//TODO: review // do
import { Theme as _ITheme } from 'baseui/theme';
export const ColorPalette = _ColorPalette;
export const ThemeColors = _ThemeColors;

export const useStyletron = _use;
export const withStyle = _withStyle;
export type StyleObject = _StyleObject;
export const Theme = _Theme;
export const BaseProvider = _BaseProvider;
export const styled = _styled;
export const LocaleProvider = _LocaleProvider;
export type ITheme = _ITheme & { // TODO: update the type
	textarea: object;
	input: object;
	button: object;
	radio: object;
	tab: object;
	dropdown: object;
	link: object;
	feedback: object;
	checkbox: object;
	toggle: object;
	notification: object;
	tooltip: object;
	panel: object;
	dialog: object;
	card: object;
	list: object;
};
